// extracted by mini-css-extract-plugin
export default {"container":"Table_container__jqn2J"};